import { useEffect, useState } from "react";
import { selectedOptic, userData } from "../js/utils";
import { post } from "../js/post";

export function useHearingAidSpecialists() {
  const [list, setList] = useState([]);

  async function getData() {
    const response = await post("ListarAudioprotesistas.php", {
      token: userData.token,
      optica: selectedOptic.id,
    });
    setList(
      response.map((e) => ({
        id: e.id,
        text: e.nombreApellidos,
      }))
    );
  }

  useEffect(() => {
    getData();
  }, []);

  return list;
}
